import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getHomeRoute } from '@/utils/auth/roleUtils';
import { ROLES } from '@/constants';

interface PublicGuardProps {
  children: React.ReactNode;
}

export function PublicGuard({ children }: PublicGuardProps) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user) {
    return <Navigate to={getHomeRoute(user.role as ROLES)} replace />;
  }
  return <>{children}</>;
}
